import { CaseProgress } from '@/contexts/MasterclassContext';

import { CaseConfig } from './types/generated';

export function getCaseSlideIndexFromProgress(
  caseContent: CaseConfig | null,
  caseProgress: Record<string, CaseProgress>,
  caseId: string | null
): number {
  if (!caseContent || !caseId) return 0;
  const progress = caseProgress[caseId];
  if (!progress) return 0;

  const currentSlideId = progress.currentSlideId;
  if (!currentSlideId) return 0;

  const slideIndex = caseContent.slides.findIndex((slide) => slide.id === currentSlideId);
  return slideIndex >= 0 ? slideIndex : 0;
}
